import { Button, ModalIsland } from '@saviynt/design-system';
import { useIntl } from 'react-intl';

import { useDeletePolicy } from '../../hooks/useAgentPolicy';

interface DeletePolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  policyId: string;
  policyName?: string;
  onDeleteSuccess?: () => void;
}

export function DeletePolicyModal({
  isOpen,
  onClose,
  policyId,
  policyName,
  onDeleteSuccess,
}: DeletePolicyModalProps) {
  const intl = useIntl();

  const deletePolicyMutation = useDeletePolicy({
    onError: () => {},
    onSuccess: () => {
      onDeleteSuccess?.();
    },
    onSettled: () => {
      onClose();
    },
  });

  const handleDelete = () => {
    deletePolicyMutation.mutate(policyId);
  };

  const handleClose = () => {
    if (!deletePolicyMutation.isPending) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ModalIsland
      kind='critical'
      alertTitle={intl.formatMessage({
        id: 'qbYTaI',
        defaultMessage: 'Are you sure?',
        description: 'Delete policy modal title',
      })}
      alertSubtitle={intl.formatMessage(
        {
          id: 'urDfJW',
          defaultMessage:
            'This action will permanently remove the rule {policyName}. It cannot be undone.',
          description: 'Delete policy modal description',
        },
        {
          policyName:
            policyName ||
            intl.formatMessage({
              id: 'idrbfc',
              defaultMessage: 'Untitled Rule',
              description: 'Default policy name when creating a new policy',
            }),
        }
      )}
      onClose={handleClose}
      isOpen={isOpen}
      primaryButton={
        <Button
          type='button'
          kind='outlined'
          isEnabled={!deletePolicyMutation.isPending}
          size='medium'
          onClick={handleDelete}>
          {intl.formatMessage({
            id: 'WodcPq',
            defaultMessage: 'Delete',
            description: 'Delete button label',
          })}
        </Button>
      }
      secondaryButton={
        <Button type='button' kind='ghost' size='medium' onClick={handleClose}>
          {intl.formatMessage({
            id: '0GT0SI',
            defaultMessage: 'Cancel',
            description: 'Cancel button label',
          })}
        </Button>
      }
    />
  );
}
